<template>
	<div>
		<waiting v-if="loaded == false" />
		<StoreList
			v-if="loaded"
			listIcon="mdi-office-building"
			listTitle="헤어샵 관리"
			:headers="headers"
			:items="items"
			@registItem="registItem"
			@modifyItem="modifyItem"
			@deleteItem="deleteItem"
		>
		</StoreList>
	</div>
</template>

<script>
	export default {
		name: 'StoreManager',
		props: {},
		data: () => ({
			headers: [
				{
					text: '생성일',
					align: 'start',
					sortable: true,
					value: 'createAt',
				},
				{
					text: '이름',
					align: 'start',
					sortable: true,
					value: 'title',
				},
				{
					text: '주소',
					align: 'start',
					sortable: true,
					value: 'address',
				},
			],
			items: [],
			loaded: false,
		}),
		mounted: async function() {
			this.items = await this.$database.loadStores();
			this.loaded = true;
		},
		methods: {
			async registItem(item) {
				item.createAt = this.$database.currentTimestamp();
				await this.$database.addStore(item);
				this.loaded = false;
				this.items = await this.$database.loadStores();
				this.loaded = true;
			},
			async modifyItem(item) {
				await this.$database.editStore(item.id, item);
				this.loaded = false;
				this.items = await this.$database.loadStores();
				this.loaded = true;
			},
			async deleteItem(id) {
				// 데이터 삭제가 아닌 상태 삭제 처리
				// await this.$database.deleteStore(id);
				await this.$database.editStore(id, {
					storeStatusType: 'StoreStatusType.delete',
					storeStatusTypeName: '삭제',
				});

				this.loaded = false;
				this.items = await this.$database.loadStores();
				this.loaded = true;
			},
		},
	};
</script>

<style scoped></style>
